import React from 'react';

import ProjectActivityForm from './ProjectActivityForm';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import Modal from 'CommonComponents/Modal';
import ModalHeader from 'CommonComponents/ModalHeader';

function CreateProjectActivityModal(props) {
    const activity = props.activity || {};
    const actions = props.actions || [];

    const close = () => {
        props.modal.hide();
    };

    const onCreated = () => {
        close();
        props.onCreated();
    };

    return (
        <Modal id={props.id} modal={props.modal} containerStyle={{ maxWidth: '60rem' }}>
            <ModalHeader dark close={close}>
                <div className="tw-text-base tw-font-medium">{$t('Add Activity')}</div>
            </ModalHeader>
            {/* Mounted only while open, so closing discards anything staged. */}
            <div className="tw-rounded-b">
                {props.modal.visible &&
                    (props.isLoading ? (
                        <LoadingSpinner />
                    ) : (
                        <div>
                            <ProjectActivityForm
                                mode="create"
                                activityTabTitle={$t('Activity')}
                                activity={activity}
                                actions={actions}
                                categoryId={props.categoryId}
                                updateUrl={props.updateUrl}
                                storeUrl={props.storeUrl}
                                deleteAttachmentUrl={props.deleteAttachmentUrl}
                                downloadAttachmentUrl={props.downloadAttachmentUrl}
                                onSuccess={props.onSuccess}
                                onCreated={onCreated}
                                onCancel={close}
                            />
                        </div>
                    ))}
            </div>
        </Modal>
    );
}

export default CreateProjectActivityModal;
